module.exports = __webpack_public_path__ + "static/media/img_Benchmarking106.72c593fe.png";